import { FeatureFlagContext } from '@hopin-team/provider-feature-flag';
import { ThemeContext, ThemeProvider } from '@hopin-team/provider-theme';
import { rcTheme } from '@hopin-team/ui-symbols';
import React, {
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { Loading } from '../../components/loading/spinner-loading-component';
import { FLAG_ENABLE_BRANDING } from '../../utils/flags';
import { getUrlDetails } from '../../utils/url';
import { loadTheme } from './load-theme';
import { mergeThemeValues } from './merge-theme-values';

export const ThemeLoader = ({ children }: PropsWithChildren<unknown>) => {
  const [themeLoadingStatus, setThemeLoadingStatus] = useState<
    'initial' | 'loading' | 'complete'
  >('initial');
  const { setCustomTheme, currentTheme } = useContext(ThemeContext);
  const { flags } = useContext(FeatureFlagContext);
  const { slug } = useMemo(getUrlDetails, []);

  useEffect(() => {
    if (themeLoadingStatus !== 'initial') return;

    const brandingEnabled = flags[FLAG_ENABLE_BRANDING] as boolean | undefined;

    if (brandingEnabled === undefined) return;

    const applyTheme = (brandColor: string | null, theme: any | null) => {
      setCustomTheme(mergeThemeValues(brandColor, rcTheme as any, theme));

      if (theme && theme['colorTextLinks'])
        document.documentElement.style.setProperty(
          `--color-text-links`,
          theme['colorTextLinks'],
        );

      setThemeLoadingStatus('complete');
    };

    if (!brandingEnabled) {
      applyTheme(null, null);
      return;
    }

    setThemeLoadingStatus('loading');
    loadTheme(slug, applyTheme);
  }, [currentTheme, flags, setCustomTheme, slug, themeLoadingStatus]);

  return themeLoadingStatus === 'complete' ? (
    <ThemeProvider>{children}</ThemeProvider>
  ) : (
    <Loading />
  );
};
